import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import FourSightMatchTickerCard from './components/FourSightMatchTickerCard';

import './FourSightTennisMatchTicker.scss';
import { useImportImageNewDesign } from '../../../../../hooks';
import mapFourSightTennisMatches from './fourSightTennisDataMapper';

const FourSightTennisMatchTicker = ({ matches }) => {
  const intl = useIntl();
  const sportIcon = useImportImageNewDesign('sport-icons-common/sport-icon-5.svg');
  const tickers = matches?.tickers || [];

  if (!tickers.length) {
    return null;
  }

  const preparedTennisFourSightMatchesStructure = mapFourSightTennisMatches(tickers);
  const translatedTitle = intl.formatMessage(
    { id: preparedTennisFourSightMatchesStructure.title.translationKey },
  );
  const titleName = preparedTennisFourSightMatchesStructure.title.name;

  return (
    <div className='flex max-w-full flex-1'>
      <div className='flex max-w-full flex-1 flex-col tennis-tournament-matches'>
        <div className='tennis-tournament-matches__title'>
          <span className='tennis-tournament-matches__icon-wrap'>
            <img src={sportIcon} alt='Tennis icon' />
          </span>
          <span className='tennis-tournament-matches__title-text font-main--bold'>
            <span className='tennis-tournament-matches__title-label'>{translatedTitle}</span>
            {titleName && (
              <span className='tennis-tournament-matches__title-tournament'>{titleName}</span>
            )}
          </span>
        </div>
        <div className='tennis-tournament-matches__grid'>
          {preparedTennisFourSightMatchesStructure.matches.map(match => {
            const status = intl.formatMessage(
              { id: match.statusLabelTranslationKey },
            ) + ` ${match.statusLabelValue}`;

            return (
              <FourSightMatchTickerCard
                key={match.matchId}
                isLive={match.isLive}
                statusLabel={status}
                currentSet={match.currentSet}
                hasOdds={match.hasOdds}
                competitors={match.competitors}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};

FourSightTennisMatchTicker.propTypes = {
  matches: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      statusLabel: PropTypes.string,
      currentSet: PropTypes.string,
      competitors: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string,
          sets: PropTypes.arrayOf(PropTypes.string),
          odds: PropTypes.string,
        }),
      ),
    }),
  ),
};

FourSightTennisMatchTicker.defaultProps = {
  matches: { tickers: [] },
};

export default FourSightTennisMatchTicker;
